export default {
  AnimalAssistanceFormField__DISCLAIMER:
    "Note: Southwest Airlines does not carry emotional support animals.",
  AnimalAssistanceFormField__HEADER: "Animal assistance",
  AnimalAssistanceFormField__SERVICE_ANIMAL: "Trained service dog - Documentation required",
};
